export default {
  metadata: {
    version: '1.0.0',
    id: 'search-result-item-1.0.0',
    name: 'JDSSearchResultItem'
  },
  hierarchy: {
    container: [
      'icon',
      {
        'text-container': ['jds_search_result_text']
      }
    ]
  },
  base: {
    container: {
      'flex-direction': '{s_0}',
      gap: '{s_1}',
      'padding-top': '{s_2}',
      'padding-bottom': '{s_3}',
      'align-items': '{s_4}',
      width: '{s_5}',
      behavior: {
        hover: {
          'background-color': '{s_6}'
        },
        active: {
          'background-color': '{s_7}'
        },
        focus: {
          'background-color': '{s_8}'
        }
      }
    },
    icon: {
      size: '{s_9}',
      color: '{s_10}'
    },
    'text-container': {
      'flex-direction': '{s_11}',
      'justify-content': '{s_12}',
      'align-items': '{s_13}'
    }
  },
  variant: {},
  combination: [{}],
  combination_config: [[]],
  api: {
    data: {
      container: {
        '_splitLabel.label': {
          type: 'string',
          name: 'label'
        },
        '_splitLabel.query': {
          type: 'string',
          name: 'query'
        }
      },
      'text-container': {
        value: {
          type: 'list',
          name: '_splitLabel',
          object: {
            bold: 'boolean',
            text: 'string'
          }
        }
      },
      jds_search_result_text: {
        text: {
          type: 'string',
          name: '_splitLabel.text'
        },
        bold: {
          type: 'boolean',
          name: '_splitLabel.bold'
        }
      },
      icon: {
        value: {
          type: 'icon',
          name: 'icon'
        }
      }
    },
    events: {
      container: {
        onClick: 'onClick'
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'listitem'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
